// this file is automatically generated by git.version.ts script
export const Versions = {version: 'undefined', revision: '3aab58b68e94ce32e027ebfd5e69c2d0218470cb', branch: 'development'};
